import { FunctionComponent, useState } from "react";
import GoogleMapReact from "google-map-react";
import { FilterSquare } from "@App/Components/FilterSquare";
import { MapIcon, MapLocationIcon } from "@App/Components/common/Icons";
import { useDeviceDimensions } from "@App/hooks/useDeviceDimensions";
import { Garage, Service } from "@App/types";
import { getConfig } from "@App/utils/getConfig";
import { DefaultMarker } from "@App/Components/molecules/common/map/markers/DefaultMarker";
import { useSelector } from "react-redux";
import { State } from "@App/state";

type GarageMapProps = {
  center: { lat: number; lng: number };
  zoom: number;
  garages: Garage[];
  service: Service;
  onClose: () => void;
  onSelectGarage: (garage: Garage) => void;
};

export const GarageMap: FunctionComponent<GarageMapProps> = ({
  center,
  zoom,
  garages,
  service,
  onClose,
  onSelectGarage,
}) => {
  const { isMobile } = useDeviceDimensions();
  const [selectedGarage, setSelectedGarage] = useState<Garage | null>(null);
  const organization = useSelector((state: State) => state.orders.organization);

  const selectMarker = (garage: Garage, open: boolean) => setSelectedGarage(open ? garage : null);

  // Map should fill the screen on mobile, minus space for the header
  const mapStyle = isMobile
    ? { width: `${window.innerWidth}px`, height: `${window.innerHeight - 64}px` }
    : {};

  const MarkerIcon = getConfig(organization).map.MarkerIcon;
  const markerContent = getConfig(organization).map.markerContent;

  return (
    <div
      id="garage-map"
      className="md:min-h-full md:h-[48rem] md:w-full fixed md:relative bottom-0 left-0 z-20"
      style={mapStyle}
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyCyOdtBEoG0atpfWsNR1VRMZPEgib8MVzY" }}
        defaultCenter={center}
        defaultZoom={zoom}
      >
        <MapLocationIcon lat={center.lat} lng={center.lng} />
        {garages.map((garage) => (
          <DefaultMarker
            key={garage.id}
            garage={garage}
            service={service}
            lat={garage.lat}
            lng={garage.lon}
            open={selectedGarage?.id === garage.id}
            onToggle={selectMarker}
            onClick={onSelectGarage}
            Icon={MarkerIcon}
            content={markerContent}
          />
        ))}
      </GoogleMapReact>
      <div className="md:hidden fixed top-20 left-1">
        <FilterSquare title="Listenansicht" onClick={onClose}>
          <MapIcon />
        </FilterSquare>
      </div>
    </div>
  );
};
